module.exports = __webpack_public_path__ + "static/banner-mobile-5a4a234721b70550923a931366e06d99.png";